import { ChevronRight } from 'lucide-react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@/Components/shadcn/button';
import JobAdPagePreviewDialog from '@/Components/JobAdPreview/JobAdPagePreviewDialog';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import NextStepButton from '../../../Components/NextStepButton';
import { JobAd } from '../../../Models/JobAd';
import { JobDetails } from '../../../Models/JobDetails';
import { JobAdFormValues, jobAdFormValues2Model } from '../JobAdStepUtils';

interface JobAdNavigationButtonsProps {
    jobAd: JobAd;
    setJobAd: (jobAd: JobAd) => void;
    jobDetails: JobDetails;
    processingState: ProcessingState;
    nextButtonLabel: string;
}

function JobAdNavigationButtons({
    jobAd,
    setJobAd,
    jobDetails,
    processingState,
    nextButtonLabel,
}: JobAdNavigationButtonsProps): React.JSX.Element {
    const { formState, getValues } = useFormContext<JobAdFormValues>();
    const { isValid } = formState;
    const [open, setOpen] = useState(false);

    const handlePreview = () => {
        setJobAd(jobAdFormValues2Model(getValues()));
        setOpen(true);
    };

    const onClose = () => setOpen(false);

    return (
        <div className="flex flex-row gap-2">
            <Button
                type="button"
                size="default"
                variant="default-outline"
                onClick={handlePreview}
                disabled={!isValid || processingState === ProcessingState.Processing}
            >
                {UIStrings.PreviewJobAd}
            </Button>
            <NextStepButton
                disabled={!isValid}
                loading={processingState === ProcessingState.Processing}
                endIcon={nextButtonLabel === UIStrings.Next && <ChevronRight className="size-5" aria-hidden />}
            >
                {nextButtonLabel}
            </NextStepButton>
            <JobAdPagePreviewDialog open={open} handleClose={onClose} jobAd={jobAd} jobDetails={jobDetails} />
        </div>
    );
}

export default JobAdNavigationButtons;
